import React from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import { legShape } from 'constants/propTypes';
import { directions } from 'constants/booking';
import SegmentInfo from '../SegmentInfo';
import { SegmentDivider } from './SegmentOrdering.styles';

const SegmentOrdering = ({
  leg,
  addOnLeg,
  productFamilyName,
  productFamilies,
  currency,
  direction,
  groupName = '',
  isMiceGroupBooking,
  infantPassengers = [],
  isLoyaltyBooking = false
}) => {
  const isAddOnBeforeMainLeg = path(['addOnLeg', 'origin', 'isPseudoStation']);
  const Leg =
    (leg && (
      <SegmentDivider key="leg" data-cy="main-leg">
        <SegmentInfo
          leg={leg}
          productFamilyName={productFamilyName}
          productFamilies={productFamilies}
          currency={currency}
          direction={direction}
          groupName={groupName}
          isMiceGroupBooking={isMiceGroupBooking}
          infantPassengers={infantPassengers}
          isLoyaltyBooking={isLoyaltyBooking}
        />
      </SegmentDivider>
    )) ||
    null;

  const AddOnLeg =
    (addOnLeg && (
      <SegmentDivider key="add-on-leg" data-cy="add-on-leg">
        <SegmentInfo
          direction={direction}
          data-cy="add-on-leg"
          leg={addOnLeg}
          isAddOnLeg
          productFamilyName={productFamilyName}
          productFamilies={productFamilies}
          currency={currency}
          groupName={groupName}
          isMiceGroupBooking={isMiceGroupBooking}
          isLoyaltyBooking={isLoyaltyBooking}
        />
      </SegmentDivider>
    )) ||
    null;

  if (isAddOnBeforeMainLeg(leg)) {
    return [AddOnLeg, Leg];
  }

  return [Leg, AddOnLeg];
};

SegmentOrdering.propTypes = {
  leg: legShape,
  addOnLeg: legShape,
  productFamilyName: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(directions).isRequired,
  groupName: PropTypes.string,
  isMiceGroupBooking: PropTypes.bool,
  infantPassengers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      passengerRef: PropTypes.string
    })
  ),
  isLoyaltyBooking: PropTypes.bool
};

export default SegmentOrdering;
